import type {
  SaleWebhookInboxStatus,
  WebhookEventType,
} from '../../domain/entities/sales.entity';

/**
 * Filtros do log de webhook inbox. Todos são aplicados **no servidor** — ver
 * `ListSaleWebhookInboxInput`.
 */
export interface SaleWebhookInboxFilters {
  status: SaleWebhookInboxStatus | '';
  eventType: WebhookEventType | '';
  providerAccountId: string;
  /** Busca (contains, case-insensitive) sobre `idempotenceSource` — a coluna "Origem". */
  idempotenceSource: string;
  from: string;
  to: string;
}

export const EMPTY_SALE_WEBHOOK_INBOX_FILTERS: SaleWebhookInboxFilters = {
  status: '',
  eventType: '',
  providerAccountId: '',
  idempotenceSource: '',
  from: '',
  to: '',
};

export function countActiveSaleWebhookInboxFilters(
  filters: SaleWebhookInboxFilters,
): number {
  return Object.values(filters).filter(Boolean).length;
}
